/**
 * Osvežavanje keševa posle prihvatanja/odbijanja moderacije iz obaveštenja.
 */
import { dispatchModeratorAssignmentChanged } from '@/shared/notifications/moderatorAssignmentEvents';
import { obligationFormKeys } from '@/features/admin/action-plans/api/queries';
import { invalidateAndRefetchProfileObligations } from './profileObligationsQuery';

/**
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {string|number|null|undefined} obligationId
 */
export async function syncAfterModeratorAssignment(queryClient, obligationId) {
  if (!queryClient) return;

  const id =
    obligationId != null && String(obligationId).trim() !== ''
      ? String(obligationId)
      : null;

  await invalidateAndRefetchProfileObligations(queryClient);

  if (id) {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: obligationFormKeys.obligation(id) }),
      queryClient.invalidateQueries({ queryKey: obligationFormKeys.relatedOrganizations(id) }),
      queryClient.invalidateQueries({ queryKey: obligationFormKeys.resolveActionPlan(id) }),
    ]);
    await queryClient.refetchQueries({
      queryKey: obligationFormKeys.obligation(id),
      type: 'all',
    });
  }

  dispatchModeratorAssignmentChanged(id);
}
